// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"725":"a09e6c2116fefee9","2567":"58a98e561c5c2a22","4342":"598ec7c49ac552ba","9774":"71abaa79c075fd66","9793":"6d10c70c6882c28d"}[chunkId] + ".css";
};